module.exports = __webpack_public_path__ + "img/dhfesta_logo3.397ce5ce.png";